import { render } from "./FirstConcept.vue?vue&type=template&id=0a24e37c"
import script from "./FirstConcept.vue?vue&type=script&lang=js"
export * from "./FirstConcept.vue?vue&type=script&lang=js"

import "./FirstConcept.vue?vue&type=style&index=0&id=0a24e37c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__